// extracted by mini-css-extract-plugin
module.exports = {"searchPriceSetting":"search-price-setting-42e"};